import { useEffect } from "react";
import PropTypes from "prop-types";
import ReactMarkdown from "react-markdown";
import "@css/About.css";
import tabsData from "../../datajson/TabsData.json";

// Общий рендер одной бывшей вкладки страницы "О клубе",
// теперь каждая - отдельная страница в разделе "Для родителей"
const TabPage = ({ tabKey, children }) => {
    const tab = tabsData[tabKey];

    useEffect(() => {
        document.title = tab?.title || "Для родителей";
    }, [tab?.title]);

    return (
        <div className="about-container">
            <h2>{tab?.title}</h2>
            <ReactMarkdown>{tab?.content}</ReactMarkdown>
            {children}
        </div>
    );
};

TabPage.propTypes = {
    tabKey: PropTypes.string.isRequired,
    children: PropTypes.node,
};

export default TabPage;
